<template>
  <div class="accountList-warp border_box">
    <wmerrortips :errmsg="errmsg">
      <template>
        <!-- 头部-搜索 -->
        <div v-if="showListData" class="accountList-head border_box">
          <div class="input-with-select flex-wrap-start border_box">
            <div class="select-box mr20">
              <van-dropdown-menu  active-color="#5090F1">
                <van-dropdown-item v-model="value" :options="option" />
              </van-dropdown-menu>
            </div>
            <div class="select-input-box">
                <input type="" class="van-field__control search-input" v-model="keyWord" placeholder="请输入">
                <img src="@/assets/images/wmSet/search_icon.png" class="search-icon" @click.stop="searchBtn" alt="">
              </div>
          </div>
        </div>
        <!-- 主体-列表 -->
        <div class="accountList-body">
          <van-list v-model="loading"
            :finished="finished"
            :finished-text="finished_text"
            @load="getAccountData">
            <van-checkbox-group v-model="checkedCities" ref="checkboxGroup" @change="handleCheckedCitiesChange">
              <div v-for="(item, index) in mediaList" :key="'acc'+index" class="table-row flex-between-start">
                <div class="table-row-index mr10">
                  <van-checkbox :name="item" shape="square"></van-checkbox>
                </div>
                <div class="table-row-body">
                  <p class="table-row-title ellipsis">{{ item.siteName }}</p>
                  <p v-if="item.siteType === '01' && item.siteDomain !== ''" class="table-row-url ellipsis">{{ item.siteDomain }}</p>
                  <p v-if="item.siteType !== '01' && item.authorId !== ''" class="table-row-url ellipsis">{{ item.authorId }}</p>
                  <div class="table-row-info flex-between">
                    <div class="table-row-info-left ellipsis">
                      <img v-if="item.siteType !== '11'" :src="siteTypeImgMap[item.siteType]" class="type-icon mr6" alt="">
                      <img v-if="item.siteType === '11'" :src="videoIcon[item.videoType]" class="type-icon mr6" alt="">
                      <span v-if="item.icp" class="table-row-icp ellipsis">{{ item.icp }}</span>
                      <span v-if="!item.icp">暂无认证信息</span>
                    </div>
                    <div class="table-row-info-right">
                      <img :src="warnIcon[item.warningFlag]" class="warn-icon cursor mr10" alt="">
                      <span v-if="item.warningFlag === true" class="warn-text-0ff cursor" @click.stop="closeWarnBtn(item)">取消预警</span>
                      <span v-if="item.warningFlag === false" class="warn-text cursor" @click.stop="openWarnBtn(item)">接收预警</span>
                    </div>
                  </div>
                </div>
              </div>
            </van-checkbox-group>
            
          </van-list>
          <div class="border_box" v-show="finished && mediaList.length === 0">
            <div class="nodata-box">
              <p>暂无数据</p>
            </div>
          </div>
        </div>
        <!-- 页尾-操作 -->
        <div  v-if="showListData" class="accountList-footer border_box flex-between">
          <!-- <van-checkbox v-model="checkedAll" shape="square" @change="handleCheckedAllChange">全选</van-checkbox> -->
          <div class="flex-wrap-start">
            <!-- 全部选中- 本身和子集都可以控制 -->
            <img v-show="checkedAllFlag === 2" src="../../assets/images/wmSet/checked.svg" @click.stop="toggleAll" class="checked-btn" alt="">
            <!-- 子集控制显示 -->
            <img v-show="checkedAllFlag === 1" src="../../assets/images/wmSet/half-checked.svg" @click.stop="checkAll" class="checked-btn" alt="">
            <!-- 全部清空-本身和子集都可以控制 -->
            <img v-show="checkedAllFlag === 0" src="../../assets/images/wmSet/unchecked.svg" @click.stop="checkAll" class="checked-btn" alt="">
            <span class="ml10 checked-tip">全选</span>
          </div>
          <div>
            <span class="warn-btn-line cursor" @click.stop="closeBatchWarnBtn()">取消预警</span>
            <span class="warn-btn-face cursor ml30" @click.stop="openBatchWarnBtn()">接收预警</span>
          </div>
        </div>
      </template>
    </wmerrortips>
  </div>
</template>

<script>
// let moment = require("moment");
import wmerrortips from './errortips.vue'
import { List, checkbox, CheckboxGroup, Dialog, Toast, DropdownMenu, DropdownItem } from 'vant';
import Clickoutside from '@/directives/clickoutside'
import { getCode, getAccountList, setWarn } from '@/api/wmAccountList'
export default {
  name:'accountList',
  components: { 
    wmerrortips,
    "van-list": List,
    "van-checkbox": checkbox,
    "van-checkbox-group": CheckboxGroup,
    "van-dropdown-menu": DropdownMenu,
    "van-dropdown-item": DropdownItem
   },    //引入了vant的checkbox组件
  directives: {
    Clickoutside
  },
  data(){
    return {
      siteTypeImgMap: {
        "01": require("@/assets/images/zombieSource/site_type_img_01.png"),
        "04": require("@/assets/images/zombieSource/site_type_img_04.png"),
        "06": require("@/assets/images/zombieSource/site_type_img_06.png"),
        "11": require("@/assets/images/zombieSource/site_type_img_11.png"),
        "12": require("@/assets/images/zombieSource/site_type_img_12.png"),
        "13": require("@/assets/images/zombieSource/site_type_img_13.png"),
        "14": require("@/assets/images/zombieSource/site_type_img_14.png"),
        "15": require("@/assets/images/zombieSource/site_type_img_15.png"),
        "16": require("@/assets/images/zombieSource/site_type_img_16.png"),
        "17": require("@/assets/images/zombieSource/site_type_img_17.png"),
        "18": require("@/assets/images/zombieSource/site_type_img_18.png"),
        "19": require("@/assets/images/zombieSource/site_type_img_19.png"),
        "20": require("@/assets/images/zombieSource/site_type_img_20.png"),
      },
      videoIcon: {
        "01": require("@/assets/images/zombieSource/video_icon01.png"),
        "02": require("@/assets/images/zombieSource/video_icon02.png"),
        "03": require("@/assets/images/zombieSource/video_icon03.png"),
        "04": require("@/assets/images/zombieSource/video_icon04.png"),
        "05": require("@/assets/images/zombieSource/video_icon05.png"),
        "06": require("@/assets/images/zombieSource/video_icon06.png"),
        "07": require("@/assets/images/zombieSource/video_icon07.png"),
        "08": require("@/assets/images/zombieSource/video_icon08.png"),
        "09": require("@/assets/images/zombieSource/video_icon09.png"),
        "10": require("@/assets/images/zombieSource/video_icon10.png"),
        "11": require("@/assets/images/zombieSource/video_icon11.png"),
      },
      warnIcon: {
        true: require("@/assets/images/wmSet/off_warn_icon.png"),
        false: require("@/assets/images/wmSet/warn_icon.png")
      },
      value: 1,
      option: [
        { text: '信源名称', value: 1 },
        { text: '域名/链接', value: 2 },
        { text: '作者ID', value: 3 }
      ],
      optionMap: {
        1: '信源名称',
        2: '域名/链接',
        3: '作者ID',
      },
      keyWord:'',
      isShowBox: false,
      cities: [],
      isIndeterminate: true,
      loading: false,          //暂停加载数据
      finished: false,         //终止加载数据
      finished_text: '',
      showListData: false,    //是否展示列表
      mediaList: [],
      // 批量操作
      checkedCities: [],
      checkedAll:false,
      batchArr: [],
      checkedAllFlag: 0,
      errmsg: 0, // 错误信息值 200无错
      // 列表
      params: {
          pageNum: 0,           //页码
          pageSize: 10,         // 每页条数
          openId: '',
          siteName: '',
          siteDomain: '',
          authorId: '',
      },
    }
  },
  created(){
    // 预警设置-媒体账号列表
    let pageUrl = this.$route.path
    if(pageUrl === '/accountlist'){
      document.querySelector("link.linkico").href = "./wmico.ico";
    }else{
      document.querySelector("link.linkico").href = "./favicon.ico";
    }
  },
  computed: {
    
  },
  mounted(){
    if (localStorage.getItem("wlgl-token")) {
      this.searchBtn()
    }else if (!!localStorage.getItem("wlgl-token") == '' && Object.keys(this.$route.query).length === 0){
      this.errmsg = 20016
    }else{
      this.init()
    }
  },
  methods:{
    init(){
      if (Object.keys(this.$route.query).length) {
        const code = this.$route.query.code
        const state = this.$route.query.state
        this.queryCode(code,state)
      }
    },
    // 获取 wlgl-token
    queryCode(code,state){
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      })
      this.loading = true
      getCode({
        code: code,
        state: state
      }).then(res=>{
        if (res.data.code === 200){
          this.errmsg = 200
          localStorage.setItem("wlgl-token", res.data.data)
          localStorage.setItem("wlgl-openId", res.data.openId)
          this.searchBtn()
        }else{
          this.errmsg = res.data.code
        }
      }).catch(err=>{
        Toast.clear()
        console.log(err);
      });
    },
    // 打开下拉框
    openSelectBox() {
      this.isShowBox = !this.isShowBox
    },
    // 关闭下拉框
    closeMask(){
      this.isShowBox = false
    },
    // 筛选数据切换
    changeSelect(val) {
      this.value = val
      this.closeMask()
    },
    // 放大镜-搜索数据
    searchBtn() {
      this.batchArr = []
      this.checkedAllFlag = 0
      this.$refs.checkboxGroup.toggleAll(false);
      this.params.siteName = ''
      this.params.siteDomain = ''
      this.params.authorId = ''
      if (this.value === 1) {
        this.params.siteName = this.keyWord
      } else if (this.value === 2) {
        this.params.siteDomain = this.keyWord
      } else {
        this.params.authorId = this.keyWord
      }
      this.mediaList = []
      this.params.pageNum = 0
      this.finished_text = ""
      this.finished = false
      this.getAccountData()
    },
    // 获取列表
    getAccountData() {
      if (!!localStorage.getItem("wlgl-token") == '' && Object.keys(this.$route.query).length === 0){
        this.errmsg = 20016
        return false
      }
      if (this.$route.query.openId && Object.keys(this.$route.query).length === 0){
        console.log('缺少openId');
        return false
      }
      // 接口响应前，先显示加载中
      this.loading = true;
      this.params.pageNum = this.params.pageNum + 1
      //  || 'o-gL86sXEYDRsfXzMI5LutKgccWI'
      this.params.openId = this.$route.query.openId
      getAccountList(this.params).then(res=>{
        if(res.data.code === 200) {
          this.showListData = true
          if (res.data.data.records && res.data.data.records.length > 0) {
            this.mediaList = [...this.mediaList, ...res.data.data.records]
            if (res.data.data.records.length <10)  {
              this.finished = true;
            }
          } else {
            this.finished = true;
          }
          if(this.mediaList.length > 0 && this.finished){
            this.finished_text = "没有更多了";
          } else {
            this.finished_text = "";
          }
          // 加载状态结束
          this.loading = false;
        }else if (res.data.code === 20009){
          this.showListData = false
          this.loading = false
          this.finished = true;
          this.finished_text = ''
          this.listData = []
          this.params = {
            state:'',
            pageSize: 10,
            pageNo: 0,
            webStatus: ''
          }
          Toast({
            type: 'html',
            message: '<div>长时间未操作<br>请退出重试！</div>'
          });
        } else {
          this.errmsg = res.data.code
          this.showListData = false
          this.loading = false;
          this.finished = true;
          this.mediaList = [];
          this.batchArr = []
          this.checkedAllFlag = 0
          this.$refs.checkboxGroup.toggleAll(false);
        }
      }).catch(err => {
        this.showListData = false
        this.loading = false;
        this.finished = true;
        this.mediaList = [];
        this.batchArr = []
        this.checkedAllFlag = 0
        this.$refs.checkboxGroup.toggleAll(false);
        Toast.fail(err.message);
      });
    },
    // 关闭预警-取消预警
    closeWarnBtn(item) {
      Dialog.confirm({
        title: '提示',
        message: '确定要取消“'+`<span style='font-weight: bold;'>`+ item.siteName+`</span>`+'”，您将不再收到该信源的预警信息。',
        confirmButtonColor: '#5090F1',
      }).then(()=> {
        const arr = [{
            siteId: item.siteId,
            siteStringId: item.siteStringId,
            siteSource: item.siteSource,
            siteType: item.siteType
          }]
        const data = {
          warnningFlag: false,
          openId: this.$route.query.openId,
          siteList: arr
        }
        setWarn(data).then(res=>{
          if (res.data.code === 200) {
            Toast.fail('修改成功');
            this.mediaList = []
            this.params.pageNum = 0
            this.finished_text = ""
            this.finished = false
            this.batchArr = []
            this.checkedAllFlag = 0
            this.$refs.checkboxGroup.toggleAll(false);
            this.getAccountData()
          } else {
            Toast.fail('修改失败');
          }
        })
      }).catch((e) => {
        // on cancel
        console.log(e);
      });
    },
    // 开启预警-接收预警
    openWarnBtn(item) {
      Dialog.confirm({
        title: '提示',
        message: '确定要接收“'+`<span style='font-weight: bold;'>`+ item.siteName+`</span>`+'”，您将开始收到该信源的预警信息。',
        confirmButtonColor: '#5090F1',
      }).then(()=> {
        const arr = [{
            siteId: item.siteId,
            siteStringId: item.siteStringId,
            siteSource: item.siteSource,
            siteType: item.siteType
          }]
        const data = {
          warnningFlag: true,
          openId: this.$route.query.openId,
          siteList: arr
        }
        setWarn(data).then(res=>{
          if (res.data.code === 200) {
            Toast.fail('修改成功');
            this.mediaList = []
            this.params.pageNum = 0
            this.finished_text = ""
            this.finished = false
            this.batchArr = []
            this.checkedAllFlag = 0
            this.$refs.checkboxGroup.toggleAll(false);
            this.getAccountData()
          } else {
            Toast.fail('修改失败');
          }
        })
      }).catch((e) => {
        // on cancel
        console.log(e);
      });
    },
    // 多选操作
    handleCheckedCitiesChange(value) {
      this.batchArr = []
      let valLen = value.length
      if (valLen === this.mediaList.length && this.mediaList.length > 0) {
        this.checkedAllFlag = 2
      } else if (valLen === 0) {
        this.checkedAllFlag = 0
      } else {
        this.checkedAllFlag = 1
      }
      this.batchArr = value
    },
    // 全选 按钮
    checkAll() {
      this.batchArr = []
      this.batchArr = this.checkedCities
      this.$refs.checkboxGroup.toggleAll(true);
    },
    // 反选 按钮
    toggleAll() {
      this.batchArr = []
      if (this.checkedAllFlag === 2 && (this.mediaList.length > this.checkedCities.length)) {
        this.checkedAllFlag = 0
        this.$refs.checkboxGroup.toggleAll(false);
      } else {
        this.batchArr = this.checkedCities
        this.$refs.checkboxGroup.toggleAll();
      }
    },
    // 批量取消-弹框
    closeBatchWarnBtn() {
      if (this.batchArr.length === 0) {
        Toast.fail('请选择需要，取消预警信息的信源');
      } else {
        Dialog.confirm({
          title: '提示',
          message: '确定要取消已选择的'+`<span style='font-weight: bold;'>`+ this.batchArr.length+`</span>`+'个信源，您将不再收到已选信源的预警信息。',
          confirmButtonColor: '#5090F1',
        }).then(()=> {
          const arr = this.batchArr.map(function(item) {
            return {
              siteId: item.siteId,
              siteStringId: item.siteStringId,
              siteSource: item.siteSource,
              siteType: item.siteType
            }
          })
          const data = {
            warnningFlag: false,
            openId: this.$route.query.openId,
            siteList: arr
          }
          setWarn(data).then(res=>{
            if (res.data.code === 200) {
              Toast.fail('修改成功');
              this.mediaList = []
              this.params.pageNum = 0
              this.finished_text = ""
              this.finished = false
              this.batchArr = []
              this.checkedAllFlag = 0
              this.$refs.checkboxGroup.toggleAll(false);
              this.getAccountData()
            } else {
              Toast.fail('修改失败');
            }
          })
        }).catch((e) => {
          // on cancel
          console.log(e);
        });
      }
    },
    // 批量添加-弹框
    openBatchWarnBtn() {
      if (this.batchArr.length === 0) {
        Toast.fail('请选择需要，接收预警信息的信源');
      } else {
        Dialog.confirm({
          title: '提示',
          message: '确定要接收已选择的'+`<span style='font-weight: bold;'>`+ this.batchArr.length+`</span>`+'个信源，您将开始收到已选信源的预警信息。',
          confirmButtonColor: '#5090F1',
        }).then(()=> {
          const arr = this.batchArr.map(function(item) {
            return {
              siteId: item.siteId,
              siteStringId: item.siteStringId,
              siteSource: item.siteSource,
              siteType: item.siteType
            }
          })
          const data = {
            warnningFlag: true,
            openId: this.$route.query.openId,
            siteList: arr
          }
          setWarn(data).then(res=>{
            if (res.data.code === 200) {
              Toast.fail('修改成功');
              this.mediaList = []
              this.params.pageNum = 0
              this.finished_text = ""
              this.finished = false
              this.batchArr = []
              this.checkedAllFlag = 0
              this.$refs.checkboxGroup.toggleAll(false);
              this.getAccountData()
            } else {
              Toast.fail('修改失败');
            }
          })
        }).catch((e) => {
          // on cancel
          console.log(e);
        });
      }
    }
  }
}
</script>

<style scoped>
  @import url("./accountlist.css");
</style>